<mat-card appearance="outlined" class="mt-4 mb-4">
  <mat-card-header>
    <mat-card-title><b>Sessione UVM</b></mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <!--<div class="mt-2 mb-2">




      <ng-container *ngIf="sessione?.confermata === true">
        <span class="badge bg-primary">Sessione UVM confermata</span>

      </ng-container>

      <ng-container *ngIf="sessione?.confermata === false">

        <span class="badge bg-secondary">Sessione UVM in attesa di conferma</span>


      </ng-container>

    </div>-->

    <br>

    <strong>ID:</strong> {{ sessione?.id }}<br>

    <strong>Data:</strong> {{ sessione?.data | date : "dd/MM/yyyy"}}<br>
    <strong>Ora Inizio:</strong> {{ sessione?.oraInizio }}<br>
    <strong>Ora Fine:</strong> {{ sessione?.oraFine }}<br>
    <!--<strong>Durata:</strong> {{ sessione?.durata }} ora<br>-->
    <!--<strong>Struttura:</strong> {{ sessione?.struttura?.descrizione }}<br>-->

    <div class="mb-4"></div>


    <strong class="mt-4">Operatori:</strong>

    <div *ngFor="let operatore of sessione?.operatori" style="margin-left:20px" class="mt-4">
      <strong>Cognome:</strong> {{ operatore?.cognome }}<br>
      <strong>Nome:</strong> {{ operatore?.nome }}<br>
      <strong>Codice Fiscale:</strong> {{ operatore?.codiceFiscale }}<br>
      <strong>Qualifica:</strong> {{ operatore?.qualifica?.descrizione }}
      <hr>
    </div>





  </mat-card-content>
</mat-card>